import { IApiClientOptions } from 'core';
import {
    CreateDeploymentGroupDetailsProps,
    DeploymentGroupDto,
    IDeploymentGroupQuery,
    UpdateDeploymentGroupDetailsProps,
} from '../dto/deployment/deployment-group-dto';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import { transform } from 'dto/transformer';

export class DeploymentGroupsApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('deploymentGroups', options);
    }

    protected getRootPath(): string {
        return 'deployment-groups';
    }

    public async getDeploymentGroupDetails(
        accountId: number,
        groupId: string,
        query?: IDeploymentGroupQuery,
    ): Promise<DeploymentGroupDto> {
        const result = await this.send<{ deploymentGroup: unknown }>(
            HTTP_METHOD.GET,
            this.getRequestOptionsWithAccountId(accountId, `${groupId}`, query),
        );
        return transform(DeploymentGroupDto, result.deploymentGroup);
    }

    public async getDeploymentGroups(accountId: number): Promise<{ deploymentGroups: DeploymentGroupDto[]; sharedDeploymentGroups?: DeploymentGroupDto[]; }> {
        const result = await this.send<{ deploymentGroups: unknown[]; sharedDeploymentGroups?: unknown[]; }>(
            HTTP_METHOD.GET,
            this.getRequestOptionsWithAccountId(accountId),
        );
        return {
            deploymentGroups: transform(DeploymentGroupDto, result.deploymentGroups || []),
            sharedDeploymentGroups: transform(DeploymentGroupDto, result.sharedDeploymentGroups || []),
        };
    }

    public async updateDeploymentGroup(
        accountId: number,
        deploymentGroupId: number,
        changedOptions: UpdateDeploymentGroupDetailsProps,
    ): Promise<DeploymentGroupDto> {
        const result = await this.send<{ deploymentGroup: unknown }>(
            HTTP_METHOD.PUT,
            this.getRequestOptionsWithAccountId(accountId, `${deploymentGroupId}`, changedOptions),
        );
        return transform(DeploymentGroupDto, result.deploymentGroup);
    }

    public async createDeploymentGroup(
        accountId: number,
        newDeploymentGroup: CreateDeploymentGroupDetailsProps,
    ): Promise<DeploymentGroupDto> {
        const result = await this.send<{ deploymentGroup: unknown }>(
            HTTP_METHOD.POST,
            this.getRequestOptionsWithAccountId(accountId, '', newDeploymentGroup),
        );
        return transform(DeploymentGroupDto, result.deploymentGroup);
    }

    public async deleteDeploymentGroup(accountId: number, deleteId: number): Promise<string> {
        const result = await this.send<{ message: string }>(
            HTTP_METHOD.DELETE,
            this.getRequestOptionsWithAccountId(accountId, `${deleteId}`),
        );
        return result.message;
    }

    public async getActiveDeploymentDetailsByGroupId(accountId: number, groupId: number): Promise<any[]> {
        const result = await this.send<{ deployments: any[] }>(
            HTTP_METHOD.GET,
            this.getRequestOptionsWithAccountId(accountId, `${groupId}/active-deployment-details`),
        );
        return result.deployments;
    }
}
